export const expensereportdata = [
  {
    id:"1",
    Expense_Name: "Electricity Payment",
    Category: "Utilities",
    Description: "Electricity Bill",
    Date: "24 Dec 2024",
    Amount: "$200",
    Status: "Approved",
  },
  {
    id:"2",
    Expense_Name: "Stationery Purchase",
    Category: "Office Supplies",
    Description: "Stationery items for office",
    Date: "10 Dec 2024",
    Amount: "$50",
    Status: "Pending",
  },
  {
    id:"3",
    Expense_Name: "AC Repair Service",
    Category: "Repairs & Maintenance",
    Description: "AC Repair for Office",
    Date: "27 Nov 2024",
    Amount: "$800",
    Status: "Approved",
  },
  {
    id:"4",
    Expense_Name: "Social Media Promotion",
    Category: "Marketing",
    Description: "Social Media Ads Campaign",
    Date: "18 Nov 2024",
    Amount: "$100",
    Status: "Approved",
  },
  {
    id:"5",
    Expense_Name: "Client Meeting",
    Category: "Travel Expenses",
    Description: "Travel fare for client meeting",
    Date: "06 Nov 2024",
    Amount: "$700",
    Status: "Approved",
  },
  {
    id:"6",
    Expense_Name: "Team Lunch",
    Category: "Employee Benefits",
    Description: "Team Lunch at Restaurant",
    Date: "25 Oct 2024",
    Amount: "$1000",
    Status: "Pending",
  },
  {
    id:"7",
    Expense_Name: "Business Flight Ticket",
    Category: "Travel Expenses",
    Description: "Flight tickets for meetings",
    Date: "14 Oct 2024",
    Amount: "$1200",
    Status: "Approved",
  },
  {
    id:"8",
    Expense_Name: "Chair Purchase",
    Category: "Office Supplies",
    Description: "Ergonomic chairs for staff",
    Date: "03 Oct 2024",
    Amount: "$750",
    Status: "Approved",
  },
  {
    id:"9",
    Expense_Name: "Plumbing Service",
    Category: "Repairs & Maintenance",
    Description: "Plumbing repairs in office",
    Date: "20 Sep 2024",
    Amount: "$450",
    Status: "Approved",
  },
  {
    id:"10",
    Expense_Name: "Internet Bill Payment",
    Category: "Utilities",
    Description: "Monthly internet subscription",
    Date: "10 Sep 2024",
    Amount: "$300",
    Status: "Pending",
  },
];
